import * as type from "../types/deliveries";

const initialState = {
  deliveries: [],
  activeId: null,
  fetchAllDeliveries: {
    error: null,
    loading: true,
  },
  deleteDelivery: {
    status: null,
    loading: false,
    error: null,
  },
  addDelivery: {
    status: null,
    loading: false,
    error: null,
  },
  showModals: {
    newModal: false,
    deleteModal: false,
    editModal: false,
    viewModal: false,
  },
};

export const deliveries = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_DELIVERIES_LISTINGS:
      return {
        ...state,
        fetchAllDeliveries: {
          ...state.fetchAllDeliveries,
          error: null,
          loading: true,
        },
      };
    case type.REVOKE_DELIVERIES_LISTINGS:
      return {
        ...state,
        deliveries: [],
        fetchAllDeliveries: {
          ...state.fetchAllDeliveries,
          error: payload.message,
          loading: false,
        },
      };
    case type.SET_DELIVERIES_LISTINGS:
      return {
        ...state,
        deliveries: payload.deliveries,
        fetchAllDeliveries: {
          ...state.fetchAllDeliveries,
          error: null,
          loading: false,
        },
      };
    case type.RESET_DELIVERIES_LISTINGS:
      return {
        ...state,
        deliveries: [],
        fetchAllDeliveries: {
          ...state.fetchAllDeliveries,
          error: null,
          loading: false,
        },
      };
    case type.CHANGE_DELIVERIES_MODALS:
      if (payload.modal.newModal === true || payload.modal.newModal === false) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            newModal: payload.modal.newModal,
          },
        };
      } else if (
        payload.modal.deleteModal === true ||
        payload.modal.deleteModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            deleteModal: payload.modal.deleteModal,
          },
        };
      } else if (
        payload.modal.editModal === true ||
        payload.modal.editModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            editModal: payload.modal.editModal,
          },
        };
      } else if (
        payload.modal.viewModal === true ||
        payload.modal.viewModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            viewModal: payload.modal.viewModal,
          },
        };
      } else {
        return state;
      }
    case type.REQUEST_ADD_SINGLE_DELIVERY:
      return {
        ...state,
        addDelivery: {
          ...state.addDelivery,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_ADD_SINGLE_DELIVERY:
      return {
        ...state,
        addDelivery: {
          ...state.addDelivery,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_ADD_SINGLE_DELIVERY:
      return {
        ...state,
        addDelivery: {
          ...state.addDelivery,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.GRANT_ADD_SINGLE_DELIVERY:
      return {
        ...state,
        addDelivery: {
          ...state.addDelivery,
          status: "success",
          loading: false,
          error: null,
        },
      };
    default:
      return state;
  }
};
